<template>
  <div class="article-list">
    <Form :model="formItem"
          ref="formItem"
          :inline="true"
          action="javascript:void(0)">
      <FormItem>
        <Select v-model="formItem.sorce"
                :style="{'width':'180px'}">
          <Option value=""
                  key="全部">全部</Option>
          <Option v-for="item in sorceSelect"
                  :value="item.value"
                  :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Input v-model="formItem.key"
               placeholder="输入关键字查询..."></Input>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="renderTable('formItem')">筛选</Button>
      </FormItem>
    </Form>
    <Table border
           :columns="columns1"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 详情的弹出 -->
    <Modal v-model="showEditInfoStatus"
           class="tuiinfo"
           title="详情"
           @on-ok="updateSetInfo()"
           :loading="dataloading">
      <Form :model="tuiinfo"
            action="javascript:void(0)">
        <FormItem label="推送"
                  label-position="top">
          <RadioGroup v-model="push_status">
            <Radio label="0">否</Radio>
            <Radio label="1">是</Radio>
          </RadioGroup>
        </FormItem>
        <div style="padding-left:20px;margin-top:20px;display: flex;"
             v-if="push_status==1">
          <!-- 商城 -->
          <div style="marginBottom:10px;marginRight:80px">
            <FormItem label-position="top">
              <Checkbox v-model="tuiinfo.push_shop_block">商城</Checkbox>
            </FormItem>
            <div v-if="tuiinfo.push_shop_block==1">
              <FormItem label-position="top"
                        label="置顶">
                <RadioGroup v-model="tuiinfo.shopblock_istop">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="排序"
                        label-position="top">
                <Input v-model="tuiinfo.shopblock_sort"
                       style="width:80px"></Input>
              </FormItem>
            </div>
          </div>
          <!-- 资讯 -->
          <div>
            <FormItem label-position="top">
              <Checkbox v-model="tuiinfo.push_zixun_block">资讯</Checkbox>
            </FormItem>
            <div v-if="tuiinfo.push_zixun_block==1">
              <FormItem label-position="top"
                        label="置顶">
                <RadioGroup v-model="tuiinfo.zixunblock_istop">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="排序"
                        label-position="top">
                <Input v-model="tuiinfo.zixunblock_sort"
                       style="width:80px"></Input>
              </FormItem>
            </div>
          </div>
        </div>
        <div>
          <FormItem label="是否置顶"
                    label-position="top">
            <RadioGroup v-model="tuiinfo.is_top">
              <Radio label="0">否</Radio>
              <Radio label="1">是</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="排序"
                    label-position="top">
            <Input v-model="tuiinfo.sort"></Input>
          </FormItem>
        </div>

      </Form>
    </Modal>
  </div>
</template>
  
  <script>
export default {
  name: 'article-list',
  data () {
    return {
      dataloading: true,
      showEditInfoStatus: false,
      cateSelect: [],
      push_status: '0',
      formItem: {
        'key': '',
        'cateid': '',
        'datetime': ''
      },
      tuiinfo: {
        'push_shop_block': "0",
        'push_zixun_block': "0",
        'shopblock_istop': "0",
        'zixunblock_istop': "0",
        'shopblock_sort': "0",
        'zixunblock_sort': "0",
        'is_top': "0",
        'sort': "0",
      },
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      sorceSelect: [
        { value: 1, label: "商城" },
        { value: 2, label: "组局儿" },
        { value: 3, label: "定制" },
        { value: 4, label: "头条" },
        { value: 6, label: "视频" },
        { value: 7, label: "直播" },
        { value: 8, label: "定位点" },
      ],
      columns1: [
        {
          title: '源数据ID',
          key: 'from_id',
          width: 100,
          fixed: 'left'
        },
        {
          title: '标题',
          width: 300,
          key: 'title'
        },
        {
          title: '分类',
          width: 150,
          key: 'cate_name'
        },
        {
          title: '来源',
          width: 150,
          key: 'sorces'
        },
        {
          title: '操作',
          key: 'action',
          width: 130,
          align: 'left',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showset(params.row.id)
                  }
                }
              }, '配置'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      selectData: [],
    }
  },
  // 计算
  computed: {
  },
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      var self = this;
      var params = { page: this.pages.current, size: this.pages.size };
      this.$api.datastream.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    changePage () {
      this.pages.current = this.$refs['listPage'].currentPage;
      this.getTableList();
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.datastream.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.renderTable();
            }
          });
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name == 1) {
        this.pages.page = 1;
      }
      var ps = {
        sorce: this.formItem.sorce,
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
      };
      this.$api.datastream.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 配置
    showset: function (index, value) {
      this.tuiinfo.id = "";
      this.showEditInfoStatus = !this.showEditInfoStatus;
      this.$api.datastream.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.tuiinfo.id = res.result.id;
          this.tuiinfo.push_shop_block = res.result.push_shop_block.toString();
          this.tuiinfo.push_zixun_block = res.result.push_zixun_block.toString();
          this.tuiinfo.shopblock_istop = res.result.shopblock_istop.toString();
          this.tuiinfo.zixunblock_istop = res.result.zixunblock_istop.toString();
          this.tuiinfo.shopblock_sort = res.result.shopblock_sort.toString();
          this.tuiinfo.zixunblock_sort = res.result.zixunblock_sort.toString();
          this.tuiinfo.sort = res.result.sort.toString();
          this.tuiinfo.is_top = res.result.is_top.toString();
          this.push_status = res.result.push_status.toString();
        } else {
          this.getTableList();
        }
      });
    },
    //更新配置
    updateSetInfo: function (index) {
      this.$api.datastream.editset(this.tuiinfo).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        } else {
          this.getTableList();
        }
      });
    },
  },
  //
}
  </script>
  <style scoped>
.tuiinfo .ivu-form-item {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.tuiinfo /deep/.ivu-form .ivu-form-item-label {
  padding: 0;
  margin-right: 10px;
}
.tuiinfo /deep/.ivu-form-item-content {
  line-height: 20px;
}
</style>
  
